import axios from 'axios'
import { camelCase, snakeCase } from 'lodash'
import qs from 'qs'
import deepMapKeys from 'packs/modules/deepMapKeys'

export default axios.create({
  transformResponse: [
    ...axios.defaults.transformResponse,
    function(data, headers) {
      if (
        !headers['content-type'] ||
        headers['content-type'].indexOf('application/json') === -1
      ) {
        return data
      }
      return deepMapKeys(data, function(val, key) {
        return camelCase(key)
      })
    }
  ],

  transformRequest: [
    function(data, headers) {
      if (data instanceof FormData) {
        return data
      }
      return deepMapKeys(data, function(val, key) {
        return snakeCase(key)
      })
    },
    ...axios.defaults.transformRequest
  ],

  paramsSerializer(params) {
    return qs.stringify(
      deepMapKeys(params, function(val, key) {
        return snakeCase(key)
      })
    )
  }
})
